<template>
  <div class="question_content_desc">
    <div class="question_header_flex">
      <div class="question_header">Q&A</div>
      <ButtonWithLoadWebsite class="question_btn">
        <svg class="link_icon">
          <use xlink:href="@/assets/img/link_plus.svg#plus"></use>
        </svg>
        <div>Add Q&A</div>
      </ButtonWithLoadWebsite>
    </div>
    <div class="question_border_h">
      <div class="question_border">
        <div class="question__border">
          <CustomSelect
            class="question_select"
            :selectedValue="selectedOption"
            :options="selectOptions"
            selectClass="question_select_"
          />
          <CustomSelect
            class="questin_select_cust"
            :selectedValue="selectedOption2"
            :options="selectOptions_2"
          />
        </div>
        <div class="question_pop">
          <div class="question_pop_answ">
            <div class="question_are">Are you a salesperson?</div>
            <div class="question_yes">Yes, I’m</div>
            <ButtonWithLoadWebsite
              class="question_pop_btn"
              title="Added from Chat History"
            />
          </div>
          <div class="question_pop_min">
            <div class="qiestion_min">55 min ago</div>
            <ButtonWithLoadWebsite
              class="question_pop_trained"
              title="Trained"
            />
          </div>
        </div>
      </div>
      <div class="question_border_2">
        <div class="question__border">
          <div class="question_answer">
            <div class="question_answer_text">Are you a salesperson?</div>
            <ButtonWithLoadWebsite
              class="question_pop_trained"
              title="Trained"
            />
          </div>
          <div class="svg_icons_cont">
            <img class="svg_icon" src="@/assets/img/question_bot.svg" alt="">
           <img src="@/assets/img/question_plan.svg" alt="">
           <img src="@/assets/img/question_delete.svg"  alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ButtonWithLoadWebsite from "../../components/shared/ButtonWithLoadWebsite.vue";
import CustomSelect from "../../components/shared/UI/CustomSelect.vue";
export default {
  components: {
    ButtonWithLoadWebsite,
    CustomSelect,
  },
  data() {
    return {
      selectedOption: "value1",
      selectedOption2: "value1",
      selectOptions: [
        { value: "value1", text: "All" },
        { value: "value2", text: "Option 2" },
        { value: "value3", text: "Option 3" },
      ],
      selectOptions_2: [
        { value: "value1", text: "Filter" },
        { value: "value2", text: "Option 2" },
        { value: "value3", text: "Option 3" },
      ],
    };
  },
};
</script>
<style>
.question_header {
  color: #4f4f4f;
  font-family: "Inter", sans-serif;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
}
.question_btn {
  width: fit-content;
  gap: 6px;
  display: flex;
  align-items: center;
}
.question_header_flex {
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 62px 38px 19px 38px;
}
.question_content_desc {
  height: calc(100% - 117px);
}
.question_select {
  width: fit-content;
}
.question_select_ {
  background: #f2f2f2 !important;
}
.question_border {
  max-width: 420px;
  width: 100%;
  height: 100%;
  border: 1px solid #ededed;
}
.question_border_2 {
  width: 100%;
  height: 100%;
  border-top: 1px solid #ededed;
  border-bottom: 1px solid #ededed;
}
.question_border_h {
  height: 100%;
  display: flex;
}
.svg_icon {
  fill: none;
}
.questin_select_cust {
  border-radius: 6px;
  width: fit-content;
  border: 1px dashed #bdbdbd;
}

.question__border {
  width: 100%;
  display: flex;
  justify-content: space-between;
  height: 74px;
  align-items: center;
  padding: 0 15px;
  border-bottom: 1px solid #ededed;
}
.question_pop {
  display: flex;
  margin: 15px;
  border-radius: 8px;
  border: 1px solid #d1d1d6;
  justify-content: space-between;
  padding: 16px;
  background: #fff;
}
.question_pop_answ {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.question_are {
  color: #333;
  font-family: "Inter", sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}
.link_icon {
  width: 28px;
  height: 28px;
}
.question_answer {
  display: flex;
  align-items: center;
  gap: 15px;
}
.qiestion_min {
  color: #bdbdbd;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}
.question_answer_text {
  color: #333;
  font-family: "Inter", sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
}

.question_pop_trained {
  color: #f8fafc;
  background: #219653 !important;
  text-align: center;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-style: normal;
  background: none;
  border-radius: 6px;
  border: 1px solid #219653;
  font-weight: 700;
  line-height: 24px;
}
.question_pop_trained:hover {
  color: #219653 !important;
  background: #f8fafc !important;
  border: 1px solid #219653 !important;
}
.question_pop_min {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end;
}
.question_yes {
  color: #333;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}
.question_pop_btn {
  display: flex;
  width: fit-content;
}
.svg_icon_delete {
  fill: none;
}
.svg_icons_cont {
  display: flex;
  gap: 16px;
}
</style>
